export default {
  'allAccounts.currentAvailableCrsSuppressed': 'Current Available (CRS Suppressed)',
  'allAccounts.openingLedger': 'Opening Ledger',
  'allAccounts.closingLedger': 'Closing Ledger',
  'allAccounts.currentLedger': 'Current Ledger',
  'allAccounts.closingAvailable': 'Closing Available',
  'allAccounts.yesterdaysValue': "Yesterday's Value",
  'allAccounts.todaysPosition': "Today's Position",
  'allAccounts.adjustedBalance': 'Adjusted Balance',
  'allAccounts.ariaLabel.viewAsTiles': 'View as tiles',
  'allAccounts.ariaLabel.viewAsTable': 'View as table',
  'allAccounts.ariaLabel.accountViewSelector': 'Accounts View'
};
